export default __webpack_public_path__ + "static/media/logo-omnix-new.a684cdaf.png";